// Generated by CoffeeScript 1.12.7
(function() {
  var merge;

  require('./Global');

  merge = function(list) {
    var i, k, l, len, out, v;
    out = {};
    for (i = 0, len = list.length; i < len; i++) {
      l = list[i];
      for (k in l) {
        v = l[k];
        out[k] = v;
      }
    }
    return out;
  };

  module.exports = global.CaffeineScriptRuntime != null ? global.CaffeineScriptRuntime : global.CaffeineScriptRuntime = merge([require('./ArrayCompactFlatten'), require('./Iteration'), require('./Iteration2'), require('./Lib'), require('./Import')]);

}).call(this);
